import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";

const FilteringComponent = ({
    t,
    onChange,
    fetchOwnersQuery
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        status: null,
        flag: null,
        owner: null
    });

    const statuses = useMemo(() => {
        return [
            {
                id: 'NEW',
                title: t('New')
            },
            {
                id: 'IN_PROGRESS',
                title: t('In Progress')
            },
            {
                id: 'OPEN',
                title: t('Open')
            },
            {
                id: 'APPROVED',
                title: t('Approved')
            },
            {
                id: 'ASSIGNED',
                title: t('Assigned')
            },
            {
                id: 'DELETED',
                title: t('Deleted')
            }
        ]
    }, [ t ]);

    const flags = useMemo(() => {
        return [
            { 
                id: true, 
                title: t("Flag On") 
            },
            { 
                id: false, 
                title: t("Flag Off") 
            }
          ];
    }, [ t ])

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'status',
                title: 'Status',
                icon: <i className="ri-toggle-line" />,
                isLoading: false,
                defaultValue: tableFilters?.status,
                data: statuses || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.title
                }
            },
            {
                type: 'radio_list',
                name: 'flag',
                title: 'Flag',
                icon: <i className="ri-flag-line" />,
                isLoading: false,
                defaultValue: tableFilters?.flag,
                data: flags || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.title
                }
            },
            {
                type: 'radio_list',
                name: 'owner',
                title: 'Owner',
                icon: <i className="ri-user-line" />,
                isLoading: fetchOwnersQuery.isFetching,
                defaultValue: tableFilters?.owner,
                data: fetchOwnersQuery.data || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.first_name + " " + item.last_name
                }
            }
        ]
    }, [
        tableFilters,
        statuses,
        flags,
        fetchOwnersQuery.isFetching,
        fetchOwnersQuery.data
    ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}

            if ('status' in filters) {
                result.status = filters.status !== 'all' ? filters.status : undefined
            }

            if ('flag' in filters) {
                result.flag = filters.flag !== 'all' ? filters.flag : undefined
            }

            if ('owner' in filters) {
                result.owner = filters.owner !== 'all' ? filters.owner : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                status: null,
                flag: null,
                owner: null
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [ 
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='status'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);
